import AttachMoneyIcon from '@mui/icons-material/AttachMoney'
import TrackChangesIcon from '@mui/icons-material/TrackChanges'
import WarningIcon from '@mui/icons-material/Warning'
import { Box, Button, CircularProgress, Popover, Stack, Typography, useTheme } from '@mui/material'

import { useEntitiesFromSearch } from 'api/search'
import { useState } from 'react'
import { useStrategy } from '../../api/aws/useStrategy'
import { renderColorByString } from '../DataGrid/renderColorByString'
import {
  boxContainerStyles,
  boxStyles,
  buttonContainerStyles,
  deleteButtonStyles,
  popoverStyles,
  textStyles,
} from './style'

const DealsPopover = ({ id, open, anchorEl, onClose, handleConfirmDelete, selectedData }) => {
  const theme = useTheme()
  const [isDeleting, setIsDeleting] = useState(false)
  const { deals, products } = useEntitiesFromSearch()
  const { strategy: currentStrategy } = useStrategy(selectedData?.PK ?? null, selectedData?.SK ?? null)
  const successorDeal = deals?.find(d => d?.deal_uuid === selectedData?.successorId)
  const predecessorDeal = deals?.find(d => d?.deal_uuid === selectedData?.predecessorId)
  const relatedProducts = products?.filter(p => p?.deal_uuid === selectedData?.deal_uuid) ?? []
  // const { deal: successorDeal, isSuccessorDealLoading } = useGetItemByPkSk(
  //   selectedData?.PK,
  //   selectedData?.successorId ? `DEAL_${selectedData?.successorId}` : null
  // )
  // const { deal: predecessorDeal, isPredecessorDealLoading } = useGetItemByPkSk(
  //   selectedData?.PK,
  //   selectedData?.predecessorId ? `DEAL_${selectedData?.predecessorId}` : null
  // )

  const handleDelete = async () => {
    setIsDeleting(true)
    try {
      await handleConfirmDelete()
      await onClose()
      setIsDeleting(false)
    } catch (error) {
      setIsDeleting(false)

      console.log('Error deleting deal: ', error)
    }
  }
  const message = `<div><span style="color: rgb(52, 211, 145);">Successor</span> has not reached deal won yet (cloned deal)</div>`
  return (
    // <Backdrop open={open} sx={{ zIndex: theme.zIndex.drawer + 1 }}>
    <>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={onClose}
        anchorOrigin={{
          vertical: 'center',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'center',
          horizontal: 'center',
        }}
        sx={popoverStyles(theme)}
      >
        <Box sx={boxContainerStyles(theme)}>
          <>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
              <WarningIcon sx={{ color: 'crimson' }} />
              <Typography sx={{ fontWeight: 'bold', color: 'crimson' }}>Confirm Deletion</Typography>
            </Box>
            <Typography style={textStyles(theme)} sx={{ mb: 2 }}>
              Are you sure you want to permanently delete the following item(s) from Grobotic?
            </Typography>
            <Box sx={{ ...boxStyles(theme), justifyContent: 'space-between' }}>
              <AttachMoneyIcon
                sx={{
                  color: '#fbc11e',
                  fontSize: 35,
                }}
              />
              <Typography style={textStyles(theme)}>{selectedData ? selectedData.name : ''}</Typography>
              {selectedData?.successorId ? (
                <Typography sx={{ fontSize: 14, color: renderColorByString('Predecessor') }}>Predecessor</Typography>
              ) : null}
            </Box>
            {currentStrategy && Object.keys(currentStrategy)?.length > 0 && currentStrategy.status !== 204 ? (
              <Box sx={boxStyles(theme)}>
                <TrackChangesIcon sx={{ fontSize: '30px', color: 'rgb(255, 202, 73)' }} />
                <Typography style={textStyles(theme)}>{currentStrategy ? currentStrategy.name : ''}</Typography>
              </Box>
            ) : null}
            {selectedData && selectedData?.predecessorId && (
              <Stack>
                <Typography>This deal was cloned, the connection will also be removed:</Typography>
                <Typography>Predecessor Id (cloned from) : {selectedData?.predecessorId}</Typography>
                {predecessorDeal && <Typography>Predecessor Deal Name: {predecessorDeal?.name}</Typography>}
              </Stack>
            )}
            {selectedData && (selectedData?.successorId || selectedData?.successorId) && successorDeal && (
              <Stack sx={{ ...boxStyles(theme), borderColor: 'background.defaultdim' }}>
                <div dangerouslySetInnerHTML={{ __html: message }} />
                {/* <Typography sx={{ padding: 1 }}>{`<div><p style={{color: ${renderColorByString(
                  'Successor'
                )}}}>Successor</p> has not reached deal won yet (cloned deal)</div>`}</Typography> */}
                <Typography sx={{ padding: 1 }}>
                  Try deleting again once the cloned deal has achieved Deal Won
                </Typography>
                {successorDeal && (
                  <Stack sx={{ ...boxStyles(theme), borderColor: 'text.subtask' }}>
                    <Box sx={{ ...boxStyles(theme), justifyContent: 'space-between', borderColor: 'transparent' }}>
                      <AttachMoneyIcon
                        sx={{
                          color: '#fbc11e',
                          fontSize: 35,
                        }}
                      />
                      <Typography style={textStyles(theme)}>{successorDeal ? successorDeal.name : ''}</Typography>
                      {successorDeal?.predecessorId ? (
                        <Typography sx={{ fontSize: 14, color: renderColorByString('Successor') }}>
                          Successor
                        </Typography>
                      ) : null}
                    </Box>
                    <Box sx={{ ...boxStyles(theme), justifyContent: 'space-between', borderColor: 'transparent' }}>
                      <Typography>Current Status</Typography>
                      <Typography sx={{ color: renderColorByString(successorDeal?.dealStatus) }}>
                        {successorDeal?.dealStatus}
                      </Typography>
                    </Box>
                  </Stack>
                )}
              </Stack>
            )}
            {selectedData && relatedProducts?.length > 0 && (
              <Stack sx={{ ...boxStyles(theme), borderColor: 'background.defaultdim' }}>
                {relatedProducts?.map(product => {
                  return (
                    <Box key={product?.SK} sx={{ ...boxStyles(theme), borderColor: 'text.subtask' }}>
                      <Typography sx={{ color: 'text.subtask' }}>Product</Typography>
                      <Typography style={textStyles(theme)}>{product ? product.productName : ''}</Typography>
                      <Typography sx={{ color: 'text.success' }}>{`$${product?.price ?? 0}`}</Typography>
                    </Box>
                  )
                })}
              </Stack>
            )}
          </>

          <Box sx={buttonContainerStyles(theme)}>
            {isDeleting && <CircularProgress />}
            <Button
              sx={deleteButtonStyles(theme)}
              variant="outlined"
              onClick={handleDelete}
              color="secondary"
              disabled={successorDeal ? true : false}
            >
              Confirm
            </Button>
            <Button variant="contained" onClick={onClose}>
              Cancel
            </Button>
          </Box>
        </Box>
      </Popover>
    </>
  )
}
export default DealsPopover
